import { WarningAmber } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface RtsNoticeDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const RtsNoticeDialog: React.FC<RtsNoticeDialogProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle sx={{display: 'flex', alignItems: 'center', gap: 1}}> <WarningAmber sx={{color: 'red'}}/>RTS now avaiable on FRONTdoor.ai</DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>Please continue in the mobile app.</Typography>
        <Typography gutterBottom>Don’t have it? Get the app below:</Typography>
        <Box display="flex" justifyContent='center' mt={2}>
          <Button
            variant="outlined"
            href="https://play.google.com/store/apps/details?id=app.thefrontdoorcollective.frontdoor.ai"
            target="_blank"
          >
           <img src="googleplaystoreicon.jpg" alt="Google Play Icon" height={25} width={25}/> Google Play
          </Button>
          {/* <Button variant="outlined" href="" target="_blank" disabled>
            App Store
          </Button> */}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RtsNoticeDialog;
